import { render, staticRenderFns } from "./CertificationViewer.vue?vue&type=template&id=4bfab81d&"
import script from "./CertificationViewer.vue?vue&type=script&lang=js&"
export * from "./CertificationViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports